import {
  Button,
  Col,
  Container,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import SearchableSingleSelectDropdown from "../../../../common/SearchableDropdown";
import { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/Store";
import Snackbar from "../../../../common/Snackbar";
import moment from "moment";
import OverlayDrawer from "../../../../common/OverlayDrawer";
import DataTable from "../../../../common/DataTable";
import { SUBJECT_LOG_HEADERS } from "../../../Case_Management/Case_Subject/actions/constant";
import {
  addStakeholderPreference,
  fetchPreferenceStakeholderAddress,
  fetchStakeholderPreferenceContact,
  fetchStakeholderPreferenceDetails,
  updateStakeholderPreference,
} from "../../../../services/StakeholderPreferenceeAPI";
import AccordionComponent from "../../../../common/Accordion";

const AddPartyPreference: React.FC<any> = ({ userData, onCancel }) => {
  const [sendRecordsOption, setSendRecordsOption] = useState<any>([]);
  const [sendRecordTo, setSendRecordTo] = useState<string | number | null>(
    null
  );
  const [dosOptions, setDOSOptions] = useState<any>([]);
  const [dos, setDOS] = useState<string | number | null>(null);
  const [signatoryOptions, setSignatoryOptions] = useState<any>([]);
  const [signatoryQME, setSignatoryQME] = useState<string | number | null>(
    null
  );
  const [preferenceID, setPreferenceID] = useState<string | number | null>(
    null
  );

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [error, setError] = useState("");
  const [preferenceLog, setPreferenceLog] = useState<any[]>([]);
  const [showLogDrawer, setShowLogDrawer] = useState(false);
  const [showLogIcon, setShowLogIcon] = useState(false);

  const [initialData, setInitialData] = useState({
    sendRecordTo: null,
    dos: null,
    signatoryQME: null,
  });

  // Fetch DOS Data (Records & QME Form options)
  const fetchDOSData = async () => {
    try {
      const recordsData = await fetchPreferenceStakeholderAddress(userData);
      setSendRecordsOption(recordsData || []);
      setDOSOptions(recordsData || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Fetch QME List based on selected `addressType`
  const fetchQMEList = async (addressType: string) => {
    try {
      const qmeData = await fetchStakeholderPreferenceContact(
        userData,
        addressType
      );
      setSignatoryOptions(qmeData || []);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Handle DOS selection change
  const handleDOSChange = (
    e: any,
    name: string,
    value: string | number | null
  ) => {
    setDOS(value);

    // Find the selected DOS option
    const selectedOption = dosOptions.find(
      (option: any) => option.value === value
    );

    // If a valid option is selected, fetch QME list using its `addressType`
    if (selectedOption) {
      setSignatoryQME("");
      fetchQMEList(selectedOption.addressType);
    }
  };

  const fetchPreferenceData = async () => {
    try {
      const preferenceData = await fetchStakeholderPreferenceDetails(userData);

      if (preferenceData) {
        setShowLogIcon(true);
        const initialSendRecordTo = preferenceData.sendRecordsToId || "";
        const initialDOS = preferenceData.qmeFormDeclarationOfServiceId || "";
        const initialSignatory = preferenceData.qmeFormSignatoryId || "";

        setPreferenceID(preferenceData.stakeholderPrefId || "");
        setSendRecordTo(initialSendRecordTo);
        setDOS(initialDOS);

        // Set initial values
        setInitialData({
          sendRecordTo: preferenceData.sendRecordsToId || "",
          dos: preferenceData.qmeFormDeclarationOfServiceId || "",
          signatoryQME: preferenceData.qmeFormSignatoryId || "",
        });

        const formattedCreatedDate = preferenceData.createdDate
          ? moment(preferenceData.createdDate).format("MM/DD/YYYY | HH:mm")
          : "N/A";

        const formattedModifiedDate = preferenceData.modifiedDate
          ? moment(preferenceData.modifiedDate).format("MM/DD/YYYY | HH:mm")
          : "N/A";

        // Store log details in state
        setPreferenceLog([
          {
            createdbyName: preferenceData.createdByName || "N/A",
            createddate: formattedCreatedDate,
            modifiedbyName: preferenceData.modifiedByName || "N/A",
            modifieddate: formattedModifiedDate,
          },
        ]);

        // If DOS is set, fetch QME List options
        if (preferenceData.qmeFormDeclarationOfServiceId) {
          const selectedOption = dosOptions.find(
            (option: any) =>
              option.value === preferenceData.qmeFormDeclarationOfServiceId
          );

          if (selectedOption) {
            await fetchQMEList(selectedOption.addressType); // Fetch signatory options

            // Wait for signatoryOptions to be updated before setting signatoryQME
            setTimeout(() => {
              setSignatoryQME(preferenceData.qmeFormSignatoryId || "");
            }, 500); // Small delay to ensure options are populated first
          }
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchDOSData();
  }, [userData]);

  useEffect(() => {
    if (dosOptions.length > 0) {
      fetchPreferenceData();
    }
  }, [dosOptions, userData]);

  const handleSaveInfo = async () => {
    const Addpayload = {
      stakeholderID: userData,
      sendRecordsToId: sendRecordTo,
      qmeFormDeclarationOfServiceId: dos,
      qmeFormSignatoryId: signatoryQME,
    };

    const Updatepayload = {
      stakeholderPrefID: preferenceID,
      stakeholderID: userData,
      sendRecordsToId: sendRecordTo,
      qmeFormDeclarationOfServiceId: dos,
      qmeFormSignatoryId: signatoryQME,
    };

    let savePrference;
    if (!preferenceID) {
      savePrference = await addStakeholderPreference(Addpayload);
    } else {
      savePrference = await updateStakeholderPreference(Updatepayload);
    }

    if (savePrference && savePrference.isSuccess) {
      setSnackbarMessage(
        preferenceID
          ? "Preference details updated successfully."
          : "Preference details added successfully."
      );
      setError("success");
      setSnackbarOpen(true);
      fetchPreferenceData();
    } else {
      setSnackbarMessage("Failed to add Preference");
      setError("error");
      setSnackbarOpen(true);
    }
  };

  const handlePDFClick = () => {
    setPreferenceLog(preferenceLog); //

    setShowLogDrawer(true);
  };

  const handleCloseLogDrawer = () => {
    setShowLogDrawer(false);
  };

  const hasChanges = () => {
    return (
      initialData.sendRecordTo !== sendRecordTo ||
      initialData.dos !== dos ||
      initialData.signatoryQME !== signatoryQME
    );
  };

  const handleBack = () => {
    onCancel();
  };

  const isSaveDisabled = !sendRecordTo || !dos || !signatoryQME;

  const [preferencesKey, setpreferencesKey] = useState<string | null>("0");

  const handlePreferenceAccordionSelect = (key: string | null) => {
    // Prevent collapsing if the same key is clicked
    if (preferencesKey === key) {
      return; // do nothing
    }
    setpreferencesKey(key || "0");
  };

  const preferencesAccordion = (
    items: { title: string; content: JSX.Element }[]
  ) => (
    <AccordionComponent
      items={items.map((item, index) => ({
        ...item,
      }))}
      activeKey={preferencesKey}
      onSelect={handlePreferenceAccordionSelect}
    />
  );

  return (
    <Container fluid className="pb-5">
      <Snackbar
        message={snackbarMessage}
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        severity={error} // Adjust the severity as needed
      />

      {preferencesAccordion([
        {
          title: "QME Appointment Notification",
          content: (
            <>
              <Row>
                <Col sm={12} className="selection_dropdown">
                  <SearchableSingleSelectDropdown
                    label="Send Records To"
                    name="sendRecords"
                    required
                    options={sendRecordsOption}
                    value={sendRecordTo}
                    onChange={(e, name, value) => setSendRecordTo(value)}
                  />
                </Col>
              </Row>

              <Row className="mt-3">
                <Col sm={12} className="selection_dropdown">
                  <SearchableSingleSelectDropdown
                    label="QME Form- Declaration of Service"
                    name="qmeForm"
                    required
                    options={dosOptions}
                    value={dos}
                    onChange={handleDOSChange} // Updated handler
                  />
                </Col>
              </Row>

              {/* Adding border-bottom after the third dropdown */}
              <Row className="mt-3 pb-1">
                <Col sm={12} className="selection_dropdown">
                  <SearchableSingleSelectDropdown
                    label="QME Form - Signatory"
                    name="signatory"
                    required
                    options={signatoryOptions}
                    value={signatoryQME}
                    onChange={(e, name, value) => setSignatoryQME(value)}
                    disabled={!dos}
                  />
                </Col>
              </Row>
            </>
          ),
        },
      ])}

      {/* Buttons Row */}
      <Row className="mt-3">
        <Col sm={12} className="d-flex align-items-center">
          <div className="d-flex align-items-center">
            {/* Back Button First */}
            <button
              type="button"
              className="btn d-flex align-items-center btn-text-border me-2"
              onClick={handleBack}
            >
              <span className="material-icons me-2">arrow_back</span>Back
            </button>

            {/* Logs Button (shown conditionally) */}
            {showLogIcon && (
              <OverlayTrigger
                placement="auto"
                overlay={
                  <Tooltip style={{ backgroundColor: "#b3e0ff" }}>Logs</Tooltip>
                }
              >
                <Button
                  type="button"
                  className="btn btn-primary d-flex align-items-center"
                  onClick={handlePDFClick}
                >
                  <span className="material-icons">description</span>
                </Button>
              </OverlayTrigger>
            )}
          </div>

          {/* Right Side - Action Buttons */}
          <div className="d-flex ms-auto">
            <Button
              variant="outline-info"
              className="d-flex align-items-center"
              onClick={async () => {
                setSendRecordTo(initialData.sendRecordTo);
                setDOS(initialData.dos);

                const selectedOption = dosOptions.find(
                  (option: any) => option.value === initialData.dos
                );

                if (selectedOption) {
                  await fetchQMEList(selectedOption.addressType); // Fetch correct signatory options
                  setSignatoryQME(initialData.signatoryQME);
                } else {
                  setSignatoryQME(""); // fallback
                }
              }}
              // disabled={isSaveDisabled || !hasChanges()}
            >
              <span className="material-icons me-2">close</span>Cancel
            </Button>
            <Button
              type="submit"
              variant="primary"
              className="ms-3 d-flex align-items-center"
              disabled={isSaveDisabled || !hasChanges()}
              onClick={handleSaveInfo}
            >
              <span className="material-icons mx-1">save</span>Save
            </Button>
          </div>
        </Col>
      </Row>
      <OverlayDrawer
        title={"Logs"}
        open={showLogDrawer}
        onClose={handleCloseLogDrawer}
        placement="bottom"
      >
        <DataTable
          headers={SUBJECT_LOG_HEADERS}
          rows={preferenceLog}
          isLogTable={true}
        />
      </OverlayDrawer>
    </Container>
  );
};

export default AddPartyPreference;
